/** UK mobile → E.164 (+44…) — matches DashboardController::sendTestMessage */
export function normalizeUkPhone(raw) {
  let phone = (raw || "").replace(/\s+/g, "");
  if (!phone) return "";
  if (phone.startsWith("+")) {
    if (phone.startsWith("+440")) {
      return "+44" + phone.slice(4);
    }
    return phone;
  }
  if (phone.startsWith("44")) {
    return "+" + phone;
  }
  return "+44" + phone.replace(/^0+/, "");
}
